import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function CookiesPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Política de Cookies
            </h1>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </button>
          </div>
          <p className="text-gray-600 mb-12">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. ¿Qué son las cookies?</h2>
              <p className="text-gray-700 leading-relaxed">
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (ordenador, tablet o móvil) cuando visita un sitio web. Las cookies permiten que el sitio web reconozca su dispositivo y almacene cierta información sobre sus preferencias o acciones pasadas.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. ¿Qué tipos de cookies utilizamos?</h2>
              
              <div className="space-y-6">
                <div className="bg-emerald-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies Técnicas (Necesarias)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    Son esenciales para el funcionamiento del sitio web. Sin estas cookies, el sitio web no puede funcionar correctamente.
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Cookies de sesión</li>
                    <li>Cookies de seguridad</li>
                    <li>Cookies de preferencias de idioma</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies Analíticas</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    Nos permiten analizar el uso del sitio web y medir y mejorar el rendimiento.
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Google Analytics: Para análisis de tráfico y comportamiento de usuarios</li>
                    <li>Duración: Hasta 2 años</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies de Funcionalidad</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    Permiten recordar las elecciones que hace (como su nombre de usuario, idioma o región) y proporcionan características mejoradas y más personales.
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Preferencias de usuario</li>
                    <li>Configuración de visualización</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies de Terceros</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    Algunas cookies son colocadas por servicios de terceros que aparecen en nuestras páginas:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Google Maps: Para mostrar mapas interactivos</li>
                    <li>Readdy Agent Widget: Para el asistente de chat y voz</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Finalidad de las cookies</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Utilizamos cookies para los siguientes propósitos:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Garantizar el correcto funcionamiento del sitio web</li>
                <li>Mejorar la experiencia de navegación del usuario</li>
                <li>Analizar el tráfico y el comportamiento de los usuarios</li>
                <li>Recordar sus preferencias y configuraciones</li>
                <li>Proporcionar contenido personalizado</li>
                <li>Mejorar nuestros servicios y contenidos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Duración de las cookies</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Cookies de sesión</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Son temporales y se eliminan cuando cierra el navegador.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Cookies persistentes</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Permanecen en su dispositivo durante un período determinado o hasta que las elimine manualmente. La duración varía según el tipo de cookie, desde unos días hasta 2 años.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. ¿Cómo gestionar las cookies?</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Puede controlar y/o eliminar las cookies según desee. Puede eliminar todas las cookies que ya están en su dispositivo y puede configurar la mayoría de los navegadores para evitar que se coloquen. Sin embargo, si hace esto, es posible que tenga que ajustar manualmente algunas preferencias cada vez que visite un sitio y que algunos servicios y funcionalidades no funcionen.
              </p>
              
              <div className="bg-emerald-50 p-6 rounded-lg space-y-3">
                <h3 className="text-lg font-bold text-gray-900 mb-3">Configuración por navegador:</h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>Google Chrome:</strong> Configuración &gt; Privacidad y seguridad &gt; Cookies y otros datos de sitios</p>
                  <p><strong>Mozilla Firefox:</strong> Opciones &gt; Privacidad y seguridad &gt; Cookies y datos del sitio</p>
                  <p><strong>Safari:</strong> Preferencias &gt; Privacidad &gt; Cookies y datos de sitios web</p>
                  <p><strong>Microsoft Edge:</strong> Configuración &gt; Cookies y permisos del sitio &gt; Cookies y datos del sitio</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Consentimiento</h2>
              <p className="text-gray-700 leading-relaxed">
                Al utilizar nuestro sitio web por primera vez, se le mostrará un aviso sobre el uso de cookies. Al continuar navegando, acepta el uso de cookies de acuerdo con esta política. Puede retirar su consentimiento en cualquier momento modificando la configuración de su navegador.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Cookies de terceros</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Algunos de nuestros socios comerciales pueden utilizar cookies en nuestro sitio web. No tenemos control sobre estas cookies y le recomendamos que consulte las políticas de privacidad de estos terceros:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><a href="https://policies.google.com/privacy" target="_blank" rel="nofollow noopener noreferrer" className="text-emerald-600 hover:underline">Política de privacidad de Google</a></li>
                <li><a href="https://readdy.ai/privacy" target="_blank" rel="nofollow noopener noreferrer" className="text-emerald-600 hover:underline">Política de privacidad de Readdy</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Actualizaciones de la política</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA se reserva el derecho de modificar esta Política de Cookies para adaptarla a novedades legislativas, jurisprudenciales o de interpretación de la Agencia Española de Protección de Datos. Cuando se produzcan cambios significativos, se notificará a los usuarios mediante un aviso en el sitio web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Más información</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Para más información sobre el uso de cookies, puede consultar:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><a href="https://www.aepd.es" target="_blank" rel="nofollow noopener noreferrer" className="text-emerald-600 hover:underline">Agencia Española de Protección de Datos (AEPD)</a></li>
                <li><a href="https://www.allaboutcookies.org" target="_blank" rel="nofollow noopener noreferrer" className="text-emerald-600 hover:underline">All About Cookies</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contacto</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Si tiene alguna pregunta sobre nuestra Política de Cookies, puede contactarnos:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg space-y-2">
                <p className="text-gray-700"><strong>Email:</strong> info@protecplus.es</p>
                <p className="text-gray-700"><strong>Teléfono:</strong> +34 900 123 456</p>
                <p className="text-gray-700"><strong>Dirección:</strong> Avenida de Madrid, 86 Nave 3 - 28500 Arganda del Rey, Madrid</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
